import { useLocation } from 'react-router-dom';

export const useIsAdmin = () => {
  return useLocation().pathname.startsWith('/admin');
};
